import { filterFollowUp, getInitialValues } from "@app/components/FormBuilder/FormBuilder";
import List from "@app/components/List";
import { Col, Container, Row } from "react-bootstrap";
import * as styles from "@app/components/ExtendedPropertyList/ExtendedPropertyList.module.scss";
import FormBuilderElements from "@app/components/FormBuilder/FormBuilderElements";
import Button from "@app/components/Button";
import React from "react";
import { DEPLOYMENT_STATE_HINTS, DEPLOYMENT_STATE_KEYS } from "@app/utils/confirmationState";
import Badge from "@app/components/Badge";
import FormSummaryElements from "@app/components/FormSummary/FormSummaryElements";
import Accordion from "@app/components/Accordion";

export function PropertyList({
	value,
	remove,
	displayKey,
	fieldsetElements,
	isFollowUp,
	overlayType,
	getPropertyData,
	mapWithName,
	mapWithNameObj,
	setEditItem,
	setShowModal,
	extendedSummary,
	errors = {},
}) {
	const panelElements = fieldsetElements
		?.filter((element) => filterFollowUp(isFollowUp, element))
		.filter(({ displayPrimary }) => !!displayPrimary);

	return (
		<List
			className={styles["list"]}
			isIndexed={overlayType !== "page"}
			items={value.map((currentValue, index) => {
				const { header, headerFormGroup } = getPropertyData(currentValue, displayKey);
				return extendedSummary ? (
					<Accordion
						key={index}
						headline={<span className={"fw-bold " + styles["header"]}>{header || headerFormGroup}</span>}
						actions={[
							...DEPLOYMENT_STATE_KEYS.map((key) =>
								extendedSummary.errorCountPerEntry?.[index][key] > 0 ? (
									<Badge
										className={styles["error-badge"]}
										key={key}
										state={key}
										dot={false}
										bg="secondary"
										label={extendedSummary.errorCountPerEntry[index][key]}
										hint={DEPLOYMENT_STATE_HINTS[key]}
									/>
								) : null,
							),
							<Button
								type={"quaternary"}
								iconBefore={"edit"}
								callback={(event) => {
									event.stopPropagation();
									setEditItem(currentValue);
									setShowModal(true);
									return false;
								}}
							/>,
							<Button
								type={"tertiary"}
								iconBefore={"bin"}
								className={"ml-10"}
								callback={(event) => {
									event.stopPropagation();
									remove(currentValue);
								}}
							/>,
						]}
						initialOpen={false}
						showInstant={false}
						className={styles["accordion"]}
					>
						{extendedSummary && (
							<FormSummaryElements
								elements={[
									{
										elementType: "subFormPage",
										formGroup: {
											elements: fieldsetElements,
										},
										formPage: { fieldsets: extendedSummary.fieldsets },
										extendedFormKey: "gefaehrdungsanalyse",
										name: extendedSummary.name,
										noHeader: true,
									},
								]}
								values={{
									[extendedSummary.name]: value.slice(index, index + 1),
								}}
								errors={errors}
								archiveMode={false}
								printMode={false}
								parentPath={`${extendedSummary.name}[${index}]`}
							/>
						)}
					</Accordion>
				) : (
					<Container className={"content"} key={index}>
						<Row className={"align-items-center"}>
							<Col xs={"auto"}>
								<span className={"fw-bold " + styles["header"]}>{header || headerFormGroup}</span>
							</Col>
							<Col className={"d-flex justify-content-end"}>
								<Row>
									<FormBuilderElements
										values={{
											...getInitialValues(mapWithName(panelElements, index)),
											...mapWithNameObj(currentValue, index),
										}}
										displayFields={mapWithName(
											panelElements.map((elem) => ({ ...elem, label: "" })),
											index,
										)}
									/>
								</Row>
							</Col>
							<Col xs={"auto"}>
								<div className={styles["error-badges"]}></div>
								<Button
									type={"quaternary"}
									iconBefore={"edit"}
									callback={() => {
										setEditItem(currentValue);
										setShowModal(true);
									}}
								/>

								<Button
									type={"tertiary"}
									iconBefore={"bin"}
									className={"ml-12"}
									callback={() => {
										remove(index);
									}}
								/>
							</Col>
						</Row>
					</Container>
				);
			})}
			noBackground={true}
		/>
	);
}
